import { render, staticRenderFns } from "./EventosAdversos.vue?vue&type=template&id=74f7a282&"
import script from "./EventosAdversos.vue?vue&type=script&lang=js&"
export * from "./EventosAdversos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports